export default "__VITE_ASSET__DkvMKRJr__"